// utils/message.js
import { Message } from 'element-ui'
import { Toast } from 'vant'
let lastTime = 0

function canShow() {
  const now = Date.now()
  if (now - lastTime < 1000) return false
  lastTime = now
  return true
}
// 判断是否移动端
const isMobile = () => {
  return window.innerWidth <= 768
}

// 成功提示
export function showSuccess(msg) {
  if (isMobile()) {
    Toast.success({
      message: msg,
      duration: 2000
    })
  } else {
    Message.success(msg)
  }
}

// 错误提示
export function showError(msg) {
  if (!canShow()) return
  if (isMobile()) {
    Toast.fail({
      message: msg,
      duration: 2500
    })
  } else {
    Message.error(msg)
  }
}

// 普通提示
export function showInfo(msg) {
  if (isMobile()) {
    Toast({
      message: msg,
      duration: 2000
    })
  } else {
    Message.info(msg)
  }
}

// 警告提示
export function showWarning(msg) {
  if (isMobile()) {
    Toast({
      message: msg,
      duration: 2000
    })
  } else {
    Message.warning(msg)
  }
}